<template>
  <div :class="classList" class="articles-selector-option">
    <button class="select-button" @click="handleClickSelectButton">
      <img :src="imageOrCoverUrl" class="thumb" />
      <div class="meta">
        <h4 class="name">{{ title }}</h4>
        <p>{{ category }}</p>
      </div>
    </button>
    <div v-if="canRemove" class="action">
      <sc-button :icon="true" variant="clean" @click="handleClickRemoveButton">
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ScButton,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "",
    },
    imageUrl: {
      type: String,
      default: "",
    },
    cover: {
      type: String,
      default: "",
    },
    canSelect: {
      type: Boolean,
      default: false,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const imageOrCoverUrl = ""
    return {
      imageOrCoverUrl,
    }
  },
  computed: {
    classList() {
      return { selectable: this.canSelect }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      if (this.cover) {
        try {
          const res = await axios.get(`${process.env.HOST}/api/downloads/image`, {
            params: { imageKey: this.cover },
          })
          this.imageOrCoverUrl = res.data.url
        } catch {
          // NOTE: fall back to the raw imageUrl so a failed cover
          // download doesn't crash the selector
          this.imageOrCoverUrl = this.imageUrl
        }
      } else {
        this.imageOrCoverUrl = this.imageUrl
      }
    },
    handleClickSelectButton() {
      if (this.canSelect) {
        this.$emit("select")
      }
    },
    handleClickRemoveButton() {
      this.$emit("remove")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 48px;
$thumbHeight: 48px;
$thumbWidth: 64px;
$padding: 10px ($space / 2);

.articles-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: $padding;

  font-family: "Sukhumvit Tadmai";

  > .select-button {
    cursor: grabbing;
    user-select: text;
  }

  &.selectable {
    padding: 0;

    > .select-button {
      padding: $padding;
      cursor: grabbing;
    }

    &:hover {
      background: #efefef;
    }
  }

  > .action {
    align-self: center;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  > .icon {
    margin-top: 5px;

    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: 20px;
    display: block;

    flex-grow: 1;

    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.thumb {
  display: block;

  border-radius: 8px;
  width: $thumbWidth;
  height: $thumbHeight;
}

.meta {
  min-width: 0;

  > .desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 0.9rem;
}

.meta p {
  font-size: 0.8rem;
  color: #777;
}

.meta .name,
.meta p {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  > .provider {
    padding-left: 15px;
  }
}
</style>
